"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "loading", "progress", "children", "disabled"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Button/index.js";
var defaultProps = {
  className: "btn btn-primary"
};
function Button(_ref) {
  var className = _ref.className,
    loading = _ref.loading,
    progress = _ref.progress,
    children = _ref.children,
    disabled = _ref.disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  loading = loading || progress;
  var defaultStyle = {
    cursor: loading ? "wait" : ""
  };
  var attributes = (0, _objectSpread2["default"])({
    className: className,
    style: (0, _objectSpread2["default"])({}, defaultStyle)
  }, props);
  return /*#__PURE__*/_react["default"].createElement("button", Object.assign({}, attributes, {
    disabled: loading || disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }), loading && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classNames["default"])("spinner-border text-secondary spinner-border-sm", children && "me-2"),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 17
    }
  }), children);
}
Button.defaultProps = defaultProps;
var _default = exports["default"] = Button;